import { gql } from "@apollo/client";

export const CREATE_INVENTORY_MANAGEMENT = gql`
  mutation CreateInventoryManagement($input: CreateInventoryManagementInput) {
    createInventoryManagement(input: $input) {
      itemId
      name
      description
      quantity
      unitPrice
      warehouseId
      barcode
      lastUpdated
      materialNumber
      materialType
      baseUnitOfMeasure
      valuationClass
      plant
      storageLocation
      batchNumber
      serialNumber
      procurementType
      mrpType
      reorderPoint
      leadTime
      standardPrice
      movingAveragePrice
      priceControlIndicator
      weight
      dimensions
      hazardousMaterialIndicator
      countryOfOrigin
      customsTariffNumber
      shelfLifeExpirationDate
      qualityInspectionIndicator
      abcIndicator
      salesOrganization
      distributionChannel
      division
      taxClassification
      availabilityCheckIndicator
      loadingGroup
      transportationGroup
      packagingMaterial
      grossWeight
      netWeight
      volumeUnit
      weightUnit
      eanUpc
      manufacturerPartNumber
      externalMaterialGroup
      internalMaterialGroup
      productHierarchy
      season
      promotion
      lifecycleStatus
      volume
    }
  }
`;






